import ItemCategory from "../../../Models/ItemCategory";
import Mediator from "../../../Utilities/Mediator";
import OrderHandler from "../OrderHandler";
import Service from "../../../Models/Service";
import Variant from "../../../Models/Variant";
import FastTrackItem from "../../../Models/ViewModels/FastTrackItem";
import { ServiceType } from "../../../Models/ServiceType";

export default class FastTrackTile {
	fastTrackItem: FastTrackItem;
	fastTrackTile: HTMLDivElement;

	constructor(fastTrackItem: FastTrackItem) {
		this.fastTrackItem = fastTrackItem;

		this.init();
	}

	private init() {
		this.createfastTrackTile();
		this.addItemCLickListener();
	}

	private createfastTrackTile() {
		this.fastTrackTile = document.createElement('div');
		this.fastTrackTile.innerText = this.fastTrackItem.serviceName;
		this.fastTrackTile.title = this.fastTrackItem.serviceName;
	}

	private addItemCLickListener() {
		this.fastTrackTile.onclick = () => {
			this.addFastTrackTile();
		}
	}

	private addFastTrackTile() {
		OrderHandler.completedSelectedItems = new Set<string>();
		const itemId = new Date().getTime().toString();

		const variant = new Variant();
		variant.id = this.fastTrackItem.variantId;
		variant.name = this.fastTrackItem.variantName;
		variant.baseCost = this.fastTrackItem.baseCost;
		variant.cost = this.fastTrackItem.cost;
		variant.productionTime = this.fastTrackItem.productionTime;
		variant.productionDepartment = this.fastTrackItem.productionDepartment;
		variant.itemId = itemId;

		const service = new Service();
		service.id = service.serviceTypeId = this.fastTrackItem.serviceId;
		service.name = this.fastTrackItem.serviceName;
		service.type = ServiceType.None;
		service.itemId = itemId;
		service.variants = [variant];

		const item = new ItemCategory();
		item.id = this.fastTrackItem.id;
		item.name = this.fastTrackItem.name;
		item.itemId = itemId;
		item.services = [service];

		OrderHandler.isFastTrack = true;
		OrderHandler.currentItems = [item];
		OrderHandler.selectedItem = item;
		OrderHandler.completedSelectedItems.add(itemId);
		OrderHandler.addSelectedItemToShoppingCart();
		Mediator.emit("finalizeBillDispatched");
	}
}
